import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { RecaptchaService } from './recaptcha.service';
import { InformeResponse } from '../types/informe-response.type';
import { VideoIppResponse } from '../types/video-ipp-response.type';

@Injectable({
  providedIn: 'root',
})
export class BffService {
  private readonly validateUuidUrl: string;
  private readonly videoIppUrl: string;
  private readonly informeUrl: string;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly configService: ConfigService,
    private readonly recaptchaService: RecaptchaService,
  ) {
    this.validateUuidUrl = `${this.configService.BASE_BACKEND}/video-ipp/validate`;
    this.videoIppUrl = `${this.configService.BASE_BACKEND}/video-ipp/properties`;
    this.informeUrl = `${this.configService.BASE_BACKEND}/video-ipp/informe`;
  }

  validateUuid(rut: string, id: string): Observable<{ valid: boolean }> {
    return new Observable((observer) => {
      this.recaptchaService.captchaTokenHeaders('login').then((headers) => {
        this.httpClient
          .post<{ valid: boolean }>(this.validateUuidUrl, { rut, id }, { headers })
          .subscribe(observer);
      });
    });
  }

  getVideoProperties(rut: string, id: string): Observable<VideoIppResponse> {
    return this.httpClient.get<VideoIppResponse>(this.videoIppUrl, {
      params: { rut, id },
    });
  }

  downloadInforme(rut: string, id: string): Observable<InformeResponse> {
    return this.httpClient.get<InformeResponse>(this.informeUrl, {
      params: { rut, id },
    });
  }
}

